import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  isLoggedIn: boolean =false;
  title = 'Loadchief Digital Waybill';
  
  constructor(private router: Router)
  {

  }
  
  
}
